import CalendarIcon from '@heroicons/react/outline/esm/CalendarIcon.js'
import MenuAlt2Icon from '@heroicons/react/outline/esm/MenuAlt2Icon.js'
import TagIcon from '@heroicons/react/outline/esm/TagIcon.js'
import UserIcon from '@heroicons/react/outline/esm/UserIcon.js'

import { CustomFieldType } from '@tribeplatform/gql-client/types'
import { CustomFieldSubtype } from '@tribeplatform/react-components/CustomField'
import { type RawFilter } from '@tribeplatform/react-components/Filters'
import { type I18nShape } from '@tribeplatform/react-components/i18n'

export const staticFiltersFactory = (intl: I18nShape): RawFilter[] => {
  const { $t } = intl
  return [
    {
      id: 'tagIds',
      key: 'tagIds',
      name: $t({
        defaultMessage: '{TAGS_CC}',
        id: 'Generics.Tags',
      }),
      type: CustomFieldType.array,
      subType: CustomFieldSubtype.TAGS,
      icon: <TagIcon />,
    },
    {
      id: 'title',
      key: 'title',
      name: $t({
        defaultMessage: 'Title',
        id: 'Generics.Title',
      }),
      type: CustomFieldType.text,
      icon: <MenuAlt2Icon />,
    },
    {
      id: 'ownerId',
      key: 'ownerId',
      name: $t({
        defaultMessage: 'Author',
        id: 'Generics.Author',
      }),
      type: CustomFieldType.relation,
      subType: CustomFieldSubtype.MEMBER,
      icon: <UserIcon />,
    },
    {
      id: 'publishedAt',
      key: 'publishedAt',
      name: $t({
        defaultMessage: 'Published date',
        id: 'Generics.PublishedDate',
      }),
      type: CustomFieldType.date,
      icon: <CalendarIcon />,
    },
  ]
}
